import React, { useEffect, useRef } from 'react';
import {
    Paper,
    Divider,
    InputBase,
    IconButton,
    Select,
    MenuItem,
    Button,
    FormControl,
    InputLabel,
} from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';
import './SCUITextFieldWithSelectBox.scss';
export const SCUITextFieldWithSelectBox = (props: any) => {
    let selectText = props.selectText ? props.selectText : 'text';
    let selectId = props.selectId ? props.selectId : 'value';
    let classname = props.sx ? 'textFieldWithButtonPaper ' : 'textFieldWithButtonPaper textButtonSelect';
    if (props.className) {
        classname = `${classname} ${props.className}`.trim();
    }

    const inputRef = useRef<HTMLInputElement | null>(null) as React.MutableRefObject<HTMLInputElement | null>;
    const mergedInputRef = (el: HTMLInputElement | null) => {
        inputRef.current = el;
        const externalRef = props.inputRef as React.Ref<HTMLInputElement> | undefined;
        if (!externalRef) return;
        if (typeof externalRef === 'function') {
            externalRef(el);
        } else {
            (externalRef as React.MutableRefObject<HTMLInputElement | null>).current = el;
        }
    };
    useEffect(() => {
        if (props.autoFocus && inputRef.current) {
            inputRef.current.focus(); // autoFocus true ise odaklanmayı zorla
        }
    }, [props.autoFocus]);

    return (
        <Paper className={classname} sx={props.sx && props.sx} style={{ marginTop: props.marginTop }}>
            <FormControl>
                <InputLabel>{props.selectPlaceHolder} </InputLabel>
                <Select
                    className={props.selectClassName}
                    style={{ height: 38 }}
                    defaultValue={1}
                    label={props.selectPlaceHolder}
                    value={props.selectValue}
                    onChange={props.onChangeSelect}
                    sx={{
                        boxShadow: 'none',
                        verticalAlign: 'middle',
                        '.MuiOutlinedInput-notchedOutline': {
                            border: 0,
                            borderRight: 1,
                            borderColor: '#e0e0e0',
                            borderRadius: 0,
                        },
                    }}
                >
                    {props.selectList &&
                        props.selectList.map((selecListItem: any) => (
                            <MenuItem value={selecListItem[selectId]} key={selecListItem[selectId]}>
                                {selecListItem[selectText]}
                            </MenuItem>
                        ))}
                </Select>
            </FormControl>
            <InputBase
                className={props.inputClassName}
                type={props.type && props.type}
                sx={{ ml: 1, flex: 1, fontSize: '1.6rem' }}
                fullWidth
                value={props.defaultText && props.defaultText}
                placeholder={props.placeholder}
                onChange={props.onChangeTextField}
                onKeyDown={props.onKeyPressTextField}
                autoFocus={props.autoFocus ? props.autoFocus : false}
                inputRef={mergedInputRef}
            />
            {props.buttonText ? (
                <Button
                    color="primary"
                    type="button"
                    onClick={props.onClickButton}
                    className={[props.buttonClassName, 'textFieldWithButton'].filter(Boolean).join(' ')}
                >
                    {props.buttonText}
                </Button>
            ) : (
                <React.Fragment>
                    <Divider sx={{ height: 30, m: 0.5 }} orientation="vertical" />
                    <IconButton
                        color="primary"
                        className={['svg_icons', props.iconButtonClassName].filter(Boolean).join(' ')}
                        type="button"
                        onClick={props.onClickButton}
                    >
                        <SearchIcon />
                    </IconButton>
                </React.Fragment>
            )}
        </Paper>
    );
};
